import { render, staticRenderFns } from "./AdminClientsProductsManagementConfigSource.vue?vue&type=template&id=47a60da4&scoped=true&"
import script from "./AdminClientsProductsManagementConfigSource.vue?vue&type=script&lang=js&"
export * from "./AdminClientsProductsManagementConfigSource.vue?vue&type=script&lang=js&"
import style0 from "./AdminClientsProductsManagementConfigSource.vue?vue&type=style&index=0&id=47a60da4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a60da4",
  null
  
)

export default component.exports